import * as React from 'react';

import { Box, Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { ScanStatus } from '../types';
import {
  StyledDateTimeWidth,
  StyledItemDescriptionWidth,
  StyledItemIdWidth,
} from '../views/ScanQueue.style';

interface StatusProps {
  status: string;
}

export const LabelRow: React.FC<StatusProps> = ({ status }) => {
  return (
    <Box px={4} py={2} m={0}>
      <Flex justifyContent="space-between">
        <StyledItemIdWidth>
          <Text fontSize={14} fontWeight="bold" data-test={`scan-queue-item-label-${status}`}>
            Item ID
          </Text>
        </StyledItemIdWidth>
        <StyledItemDescriptionWidth>
          {status === ScanStatus.Done ? (
            <Text
              fontSize={14}
              fontWeight="bold"
              data-test={`scan-queue-item-description-label-${status}`}
            >
              Item
            </Text>
          ) : null}
        </StyledItemDescriptionWidth>
        <StyledDateTimeWidth>
          <Text fontSize={14} fontWeight="bold" data-test={`scan-queue-time-updated-${status}`}>
            When
          </Text>
        </StyledDateTimeWidth>
      </Flex>
    </Box>
  );
};
